import { gql } from '@apollo/client';

const APP_PURCHASE_DETAILS_FRAGMENT = gql`
  fragment BaseAppPurchaseDetails on AppPurchaseDetails {
    title
    description
    url
    salesQuoteUrl
    webstoreUrl
  }
`;

export default APP_PURCHASE_DETAILS_FRAGMENT;
